module.exports = __webpack_public_path__ + "static/media/comdlg32_530.08d5aa76.ico";